import { render, staticRenderFns } from "./InternalBudgetItemsEdit.vue?vue&type=template&id=4fd66239&scoped=true&"
import script from "./InternalBudgetItemsEdit.vue?vue&type=script&lang=ts&"
export * from "./InternalBudgetItemsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd66239",
  null
  
)

export default component.exports